import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as CashflowIcn } from '../../../../icons/cashflow-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const CashFlow = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/dashboard'];

  return (
    <ListItem>
      <Link to="/app/dashboard" className="flex">
        <CashflowIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('CASHFLOW')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default CashFlow;
